import { AuthenticationData, LoginPayload } from '@/types/coda-qa-user/auth.types';
import { CurrentUser } from '@/types/user/user.entity';
import { UserPermission } from '@/types/coda-qa-user/permissions.types';
import AxiosService from '@/api/ApiBase';

class AuthenticationService {
  login(payload: LoginPayload) {
    return AxiosService.post<AuthenticationData>('user/auth/signin', payload);
  }

  refreshTokens(refreshToken: string) {
    return AxiosService.put<AuthenticationData>('user/auth/refresh', null, {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });
  }

  getUserData(accessToken: string) {
    return AxiosService.get<CurrentUser>('user/auth/user', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getUserPermissions(accessToken: string) {
    return AxiosService.get<UserPermission>('user/auth/permission', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default new AuthenticationService();
